import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getMe, logout as logoutApi } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await getMe();
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Skip /me check if on callback page — AuthCallback handles it
    const path = window.location.pathname;
    const href = window.location.href;
    if (href.includes("session_id=") || path === "/auth/callback") {
      setLoading(false);
      return;
    }
    // Skip on auth pages — no session expected
    if (path === "/auth" || path === "/select-role") {
      setLoading(false);
      // Still try to check auth silently
      checkAuth();
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const handleLogout = async () => {
    try {
      await logoutApi();
    } catch { /* ignore */ }
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, loading, logout: handleLogout, refreshUser: checkAuth }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
